/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespCategoryTiles_itemSearch = {
    readonly displayUriRef: string | null;
    readonly categoryTiles: ReadonlyArray<{
        readonly displayName: string | null;
        readonly rank: number | null;
        readonly url: string | null;
        readonly image: string | null;
        readonly masterImage: string | null;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedCategoryTilesTracking_itemSearch">;
    readonly " $refType": "SbRespCategoryTiles_itemSearch";
};
export type SbRespCategoryTiles_itemSearch$data = SbRespCategoryTiles_itemSearch;
export type SbRespCategoryTiles_itemSearch$key = {
    readonly " $data"?: SbRespCategoryTiles_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespCategoryTiles_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespCategoryTiles_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "displayUriRef",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "categoryTiles",
      "storageKey": null,
      "args": null,
      "concreteType": "SearchBrowseCategoryTiles",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "displayName",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "rank",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "url",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "image",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "masterImage",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedCategoryTilesTracking_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = '08906dc1ec1f9d5b67ca55ae05c2a6f3';
export default node;
